import ResponseHandler from './handlers/response-handler';
import MarkdownUtility from './utils/markdown-utility';
import {DefaultSettings, settings} from '../../../settings/settings-util';
import {Reducer, Store} from "redux";
import {AlmeState, defaultState} from "../../../wireup/AlmeState";
import DisplayLinksRenderer from "../../message-renderer-display-links/src/message-renderer-display-links";


export default class MarkdownProcessor
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _markdownUtility: MarkdownUtility;
    _responseHandler: ResponseHandler;


    //#region Public Interface

    constructor(passedSettings: DefaultSettings | null, linkHandler: DisplayLinksRenderer)
    {
        this._settings = passedSettings ?? settings;
        this._markdownUtility = new MarkdownUtility(this._settings, linkHandler);
        this._responseHandler = new ResponseHandler(this._settings, this._markdownUtility);
    }

    static getDefaultSettings(): DefaultSettings
    {
        return settings;
    }

    getReducer(): Reducer<AlmeState>
    {
        return (state: AlmeState = defaultState): AlmeState => state;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
        this._responseHandler.initialize(store);
    }

    getResponseHandler(): ResponseHandler
    {
        return this._responseHandler;
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-markdown/src/response-handler-markdown.ts